var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13 Copy1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.875,0 L13.125,0 C13.6082492,-8.87714298e-17 14,0.391750844 14,0.875 L14,13.125 C14,13.6082492 13.6082492,14 13.125,14 L0.875,14 C0.391750844,14 5.91809532e-17,13.6082492 0,13.125 L0,0.875 C-5.91809532e-17,0.391750844 0.391750844,8.87714298e-17 0.875,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "england-flag"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#C8414B",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "spain",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375,0 L3.0625,0 C1.371125,0 0,1.371125 0,3.0625 L0,10.9375 C0,12.628875 1.371125,14 3.0625,14 L10.9375,14 C12.628875,14 14,12.628875 14,10.9375 L14,3.0625 C14,1.371125 12.628875,0 10.9375,0 Z",
    id: "Path",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFD250",
    x: 0,
    y: 2.91566406,
    width: 14,
    height: 8.16867187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10014453,7.01126563 L6.32586719,6.09073828 C6.34664844,6.00597266 6.27547266,5.92555469 6.17966016,5.92555469 L6.02065625,5.92555469 C5.92484375,5.92555469 5.85364062,6.00597266 5.87444922,6.09073828 L6.10014453,7.01126563 Z",
    id: "Path",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 5.83378906,
    y: 6.52859375,
    width: 1,
    height: 2.05078125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB446",
    x: 5.70089844,
    y: 6.28742187,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.877425, 5.925555)",
    fill: "#C8414B"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.29081708,
    y: 1.08565625,
    width: 1.33112109,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.62207489 2.05078125 3.82339129 1.8095 3.82339129 1.56824609 4.62207489 1.8095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.229328795,1.08571094 L0.455051451,0.165183594 C0.475832701,0.0804179688 0.40465692,0 0.30884442,0 L0.149840513,0 C0.0540280135,0 -0.0171751115,0.0804179688 0.00363348221,0.165183594 L0.229328795,1.08571094 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.03854688,6.28744922 C2.89151953,6.28744922 2.77232813,6.39545703 2.77232813,6.52873047 L2.77232813,8.09697656 C2.77232813,8.39012891 3.07423047,8.94140625 4.10347656,8.94140625 C5.13272266,8.94140625 5.434625,8.39010156 5.434625,8.09697656 L5.434625,6.52873047 C5.434625,6.39548438 5.31543359,6.28744922 5.16840625,6.28744922 L3.03854688,6.28744922 L3.03854688,6.28744922 Z",
    id: "Path",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.772301, 6.287449)",
    fill: "#C8414B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33114844,1.20635156 L0,1.20635156 L0,0.253449219 C0,0.113476563 0.113476563,0 0.253449219,0 L1.33114844,0 L1.33114844,1.20635156 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33114844,1.20635156 L2.66229688,1.20635156 L2.66229688,1.77909375 C2.66229688,2.12901172 2.37863281,2.41270313 2.0286875,2.41270313 L1.96475781,2.41270313 C1.61483984,2.41270313 1.33114844,2.12903906 1.33114844,1.77909375 L1.33114844,1.20635156 L1.33114844,1.20635156 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.77230078,7.49380078 L4.10344922,7.49380078 L4.10344922,8.06654297 C4.10344922,8.41646094 3.81978516,8.70015234 3.46983984,8.70015234 L3.40591016,8.70015234 C3.05599219,8.70015234 2.77230078,8.41648828 2.77230078,8.06654297 C2.77230078,8.06654297 2.77230078,7.49380078 2.77230078,7.49380078 Z",
    id: "Path",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.038547, 7.493801)",
    fill: "#C8414B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.798683594,1.08297656 L0.798683594,0 L0.532464844,0 L0.532464844,1.19418359 C0.631449219,1.17594531 0.720945313,1.13621484 0.798683594,1.08297656 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.26621875,1.19418359 L0.26621875,0 L0,0 L0,1.08297656 C0.0777382813,1.13621484 0.167207031,1.17594531 0.26621875,1.19418359 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFB441",
    x: 3.0384375,
    y: 7.01121094,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.038437, 6.528594)",
    fill: "#FAB446"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.133164062,
    y: 0.143554688,
    width: 1,
    height: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 1.84050781,
    y: 6.52859375,
    width: 1,
    height: 2.05078125
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.707344, 6.287422)",
    fill: "#FAB446"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 2.17136719,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5064AA",
    x: 1.57417969,
    y: 8.70023438,
    width: 1.06490234,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB446",
    x: 5.83378906,
    y: 8.45878906,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5064AA",
    x: 5.56773437,
    y: 8.70023438,
    width: 1.06490234,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB446",
    x: 3.30476562,
    y: 6.04625,
    width: 1.59742187,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFB441",
    x: 3.9703125,
    y: 5.32246094,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.905437, 4.960484)",
    fill: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.931792969,0.723789062 C0.71159375,0.723789062 0.532464844,0.561449219 0.532464844,0.361894531 C0.532464844,0.162339844 0.71159375,0 0.931792969,0 C1.15199219,0 1.33112109,0.162339844 1.33112109,0.361894531 C1.33112109,0.561449219 1.15199219,0.723789062 0.931792969,0.723789062 Z M0.931792969,0.241253906 C0.858347656,0.241253906 0.798683594,0.295339844 0.798683594,0.361894531 C0.798683594,0.428449219 0.858347656,0.482535156 0.931792969,0.482535156 C1.00523828,0.482535156 1.06490234,0.428449219 1.06490234,0.361894531 C1.06490234,0.295339844 1.00523828,0.241253906 0.931792969,0.241253906 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46423047,0.723789062 C1.24403125,0.723789062 1.06490234,0.561449219 1.06490234,0.361894531 C1.06490234,0.162339844 1.24403125,0 1.46423047,0 C1.68442969,0 1.86355859,0.162339844 1.86355859,0.361894531 C1.86355859,0.561449219 1.68445703,0.723789062 1.46423047,0.723789062 Z M1.46423047,0.241253906 C1.39078516,0.241253906 1.33112109,0.295339844 1.33112109,0.361894531 C1.33112109,0.428449219 1.39078516,0.482535156 1.46423047,0.482535156 C1.53767578,0.482535156 1.59733984,0.428449219 1.59733984,0.361894531 C1.59733984,0.295339844 1.53767578,0.241253906 1.46423047,0.241253906 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99669531,0.965070313 C1.77649609,0.965070313 1.59736719,0.802730469 1.59736719,0.603175781 C1.59736719,0.403621094 1.77649609,0.24128125 1.99669531,0.24128125 C2.21689453,0.24128125 2.39605078,0.403621094 2.39605078,0.603175781 C2.39605078,0.802730469 2.21689453,0.965070313 1.99669531,0.965070313 Z M1.99669531,0.482535156 C1.92325,0.482535156 1.86358594,0.536621094 1.86358594,0.603175781 C1.86358594,0.669730469 1.92325,0.723816406 1.99669531,0.723816406 C2.07014062,0.723816406 2.12980469,0.669730469 2.12980469,0.603175781 C2.12980469,0.53659375 2.07014062,0.482535156 1.99669531,0.482535156 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.399328125,0.965070313 C0.179128906,0.965070313 0,0.802730469 0,0.603175781 C0,0.403621094 0.179128906,0.24128125 0.399328125,0.24128125 C0.619527344,0.24128125 0.79865625,0.403621094 0.79865625,0.603175781 C0.79865625,0.802730469 0.619527344,0.965070313 0.399328125,0.965070313 Z M0.399328125,0.482535156 C0.325882813,0.482535156 0.26621875,0.536621094 0.26621875,0.603175781 C0.26621875,0.669730469 0.325882813,0.723816406 0.399328125,0.723816406 C0.472773438,0.723816406 0.5324375,0.669730469 0.5324375,0.603175781 C0.5324375,0.53659375 0.472773438,0.482535156 0.399328125,0.482535156 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.90213281,7.97633594 L4.90213281,8.09697656 C4.90213281,8.16350391 4.84241406,8.21761719 4.76902344,8.21761719 C4.69563281,8.21761719 4.63591406,8.16350391 4.63591406,8.09697656 L4.63591406,7.97633594 L4.90213281,7.97633594 M5.16835156,7.73505469 L4.36966797,7.73505469 L4.36966797,8.09694922 C4.36966797,8.29650391 4.54882422,8.45884375 4.76899609,8.45884375 C4.98919531,8.45884375 5.16835156,8.29647656 5.16835156,8.09694922 L5.16835156,7.73505469 L5.16835156,7.73505469 Z",
    id: "Shape",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78179297,7.25251953 L4.75622656,7.25251953 C4.61625391,7.25251953 4.50277734,7.13904297 4.50277734,6.99907031 L4.50277734,6.78215234 C4.50277734,6.64217969 4.61625391,6.52870312 4.75622656,6.52870312 L4.78179297,6.52870312 C4.92176562,6.52870312 5.03524219,6.64217969 5.03524219,6.78215234 L5.03524219,6.99907031 C5.03524219,7.13907031 4.92176562,7.25251953 4.78179297,7.25251953 Z",
    id: "Path",
    fill: "#FFA0D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5064AA",
    cx: 4.10347656,
    cy: 7.49382813,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB446",
    x: 3.9703125,
    y: 4.83984375,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30476563,6.04619531 L3.03854688,5.80491406 L3.19448828,5.66357422 C3.43555078,5.44509766 3.76252734,5.32237891 4.10344922,5.32237891 L4.10344922,5.32237891 C4.44437109,5.32237891 4.77134766,5.445125 5.01241016,5.66357422 L5.16835156,5.80491406 L4.90213281,6.04619531 L3.30476563,6.04619531 Z",
    id: "Path",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.437984, 5.684164)",
    fill: "#FFD250"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.665492188,
    cy: 0.120640625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.133109375,
    cy: 0.120640625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.197875,
    cy: 0.120640625,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.707344, 7.011211)",
    fill: "#C8414B"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1.33112109,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.46875035e-05 0.965125 0.798738281 0.72384375 0.798738281 0.482589844 5.46875035e-05 0.72384375"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishFlag);
export default __webpack_public_path__ + "static/media/spanish_flag.1418449c94f6f9cd1e3d9c02725bc930.svg";
export { ForwardRef as ReactComponent };